import { SanityBlock } from '@sanity/client';

export enum StepByStepListVariant {
  Secondary = 'secondary',
  Outline = 'outline',
}

export enum StepByStepListType {
  Numbered = 'numbered',
  Plain = 'plain',
}

export interface StepByStepListProps {
  title?: string;
  ingress?: string;
  list: {
    _key?: string;
    title?: string;
    body?: SanityBlock[];
  }[];
  variant?: string;
  listType?: StepByStepListType;
}
